<template>
    <div class="home">

    <van-row class="bannar">
      <van-col span="24" class="bannar-box">
        <div>
            <van-swipe :autoplay="3000" lazy-render style="width:100%">
            <van-swipe-item v-for="image in images" :key="image" style="width:100%">
                <img style="width:100%" :src="image" />
            </van-swipe-item>
            </van-swipe>
        </div>
        <div class="bannar-content">
            今题AI人工之智能学习系统
        </div>
        <div class="bannar-btn-div">
            <el-button type="primary" round class="bannar-btn">精准定位薄弱点，快速提高成绩</el-button>
        </div>
      </van-col>
    </van-row>

    <el-row class="main-box">
        <div style="width:100%;text-align: right;" >
            <el-col :span="24" class="box-item-top" >
                <div class="box-title">
                    历年真题
                </div>
                <div class="box-english-title"> 
                    TRUE QUESTIONS OVER THE YEARS
                </div>
            </el-col>
            <el-col :span="24" class="box-item-bottom" >
                <div class="box-item-bottom-item">包含2017年至2022年N1、N2、历年真题</div>
                <div class="box-item-bottom-item">突破重点内容,反复练习真题,掌握更好更容易拿分</div>
                <div class="box-item-bottom-item">检验学习效果,充分挖掘做题过程中反应出的知识点掌握方面的缺漏，对学习大有裨益</div>
                <div class="box-item-bottom-item">把握命题思路,在做题过程中不断总结和体会，理解命题专家的思路</div>
                <div class="box-item-bottom-item">提高实战经验,提前体验高考的氛围，提高应试的实战经验</div>

 
            </el-col>
        </div>
        <div style="position: absolute; width:100%">
            <el-col :span="8" :offset="2">
                <img src="http://foo.ibianma.com/jingying/word/2022/11/14/e5a1d28f433a835839584448eafa47e5.png" style="width:100%" alt="">
            </el-col>
            <el-col>
            <div class="box-btn">
                 <router-link to="/yearslist">
                    <el-button type="primary">开始测试</el-button>
                </router-link>
                
            </div>
            </el-col>
        </div>

    </el-row>

    <el-row class="main-box">
        <div style="width:100%;text-align: left;" >
            <el-col :span="24" class="box-item-top" >
                <div class="box-title">
                    水平测试
                </div>
                <div class="box-english-title"> 
                    L E V E L <span></span> T E S T
                </div>
            </el-col>
            <el-col :span="24" class="box-item-bottom" >
                <div class="box-item-bottom-item">全面覆盖能力考试N5到N1各个级别</div>
                <div class="box-item-bottom-item">学员登录之后即可根据自己所学阶段选择相对应的水平测试</div>
                <div class="box-item-bottom-item">测试完毕之后第一时间公布测试结果</div>
                <div class="box-item-bottom-item">帮助学生精准检测自己的日语水平</div>
                <div class="box-item-bottom-item">为科学合理的规划，下一步课程提供精准的数据化支持</div>

 
            </el-col>
        </div>
        <div style="position: absolute; width:100%">
            <el-col :span="8" :offset="14">
                <img src="http://foo.ibianma.com/jingying/word/2022/11/14/05d8b07d98ad163745bc9475ea68a587.png" style="width:100%" alt="">
            </el-col>
            <el-col>
            <div class="box-btn2">
                <router-link to="/leveltest">
                    <el-button type="primary">开始测试</el-button>
                </router-link>
            </div>
            </el-col>
        </div>

    </el-row>


    <el-row class="">


    </el-row>

    

<!-- 

    <van-row class="content-card">
        <van-col span="24">
            <el-card class="box-card">
                <div class="card-top">
                    一测一练
                </div>

                <router-link to="/leveltest">
                    <img style="width:100%;padding-bottom:5px;" src="http://foo.ibianma.com/jingying/word/2022/11/08/5cb3546fec10432fa28832614f784fb0.png" alt="">
                </router-link>
                
                <router-link to="/article/30">
                    <img style="width:100%" src="http://foo.ibianma.com/jingying/word/2022/11/08/4ec98d4504bec79bbd266ece3a034173.png" alt="">
                </router-link>
         

            </el-card>
        </van-col>
    </van-row> -->

    </div>
</template>

<script>
    import {fetchFocus, fetchList, articleList} from '../api'

    export default {
        name: 'Home',
        props: ['cate', 'words'],
        data() {
            return {
                images: [
                    "http://foo.ibianma.com/jingying/word/2022/11/11/b7790f8b41cf786f86eb0fe6a5738934.png"
                ],
                features: [],
                postList: [],
                currPage: 1,
                hasNextPage: false,
                listQuery:{

                }
            }
        },
        components: {
        },
        computed: {
        },
        methods: {
            
        },
        mounted() {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = '/js/audioplay/audioplayerengine/jquery.js';
            document.body.appendChild(script);

            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = '/js/audioplay/audioplayerengine/amazingaudioplayer.js';
            document.body.appendChild(script);

            
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = '/js/audioplay/audioplayerengine/initaudioplayer-1.js';
            document.body.appendChild(script);

        }
    }
</script>
<style scoped lang="less">
    // .home {
    //     padding: 0 2%;
    // }
    // .bannar{
    //     padding-top:10px;
    // }
    .bannar-box{
        width: 100%;
        font-size: 0px;
        position: relative;
    }
    .bannar-content{
        position: absolute;
        top: 15vw;
        left: 11.56vw;
        display: flex;
        flex-flow: column;
        font-size: 2.5vw;
        color: #409EFF;
        align-items: center;
 
    }
    .bannar-btn-div{
                position: absolute;
        top: 24vw;
        left: 14vw;
        display: flex;
        flex-flow: column;
        font-size: 2.5vw;
        color: #409EFF;
        align-items: center;
    }
    .bannar-btn{
        color: #409EFF;
        background-color: #fff;
        font-size: 1.5vw;
        border-radius: 100px;
    }
    .box-item-bottom-item{
        margin-top:1.5vh;
    }


    .main-box{
        margin-top:10vh;
        position: relative;
    }
    .box-title{
        margin-top:10vh;
        font-size:1.8vw;
        font-weight: bold;
    }
    .box-english-title{
        font-size:1.2vw;
        margin-top:2vh;
    }

    .box-item-top{
        height:20vh;
        padding:0 15%;
    }
    .box-item-bottom{
        height:45vh;
        padding:0 15%;
        padding-top:8vh;
        background-color: rgb(198, 226, 255);
        font-size:1.1vw;
        color:#ADADAD
    }
    .box-btn{
        margin-top:5vh;
        position: absolute;
        left: 80vw;
        top: 46vh;
    }

    .box-btn2{
        margin-top:5vh;
        position: absolute;
        left: 15vw;
        top: 46vh;
    }

    .content-card {
        margin-top:10px;
    }
    .card-top{
        margin-bottom:10px;
    }

    .site-content {
        .notify {
            margin: 60px 0;
            border-radius: 3px;
            & > div {
                padding: 20px;
            }
        }


        .search-result {
            padding: 15px 20px;
            text-align: center;
            font-size: 20px;
            font-weight: 400;
            border: 1px dashed #ddd;
            color: #828282;
        }
    }

    .top-feature {
        width: 100%;
        height: auto;
        margin-top: 30px;

        .feature-content {
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            position: relative;

            .feature-item {
                width: 32.9%;
            }
        }
    }

    .site-main {
        padding-top: 80px;

        &.search {
            padding-top: 0;
        }
    }

    .more{
        margin: 50px 0;
        .more-btn{
            width: 100px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #ADADAD;
            border: 1px solid #ADADAD;
            border-radius: 20px;
            margin: 0 auto;
            cursor: pointer;
            &:hover{
                color: #8fd0cc;
                border: 1px dashed #8fd0cc;
            }
        }
    }

    /******/
    @media (max-width: 800px) {
        .top-feature {
            display: none;
        }

        .site-main {
            padding-top: 40px;
        }

        .site-content {
            .notify {
                margin: 30px 0 0 0;
            }

            .search-result {
                margin-bottom: 20px;
                font-size: 16px;
            }
        }
    }

    /******/
</style>
